import React, { useState, useEffect, useRef } from 'react';
import './App.css';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";
import { FiArrowLeft } from 'react-icons/fi';
const discountTypes = [

  { code: 'MEGA90OFF', text: '90% OFF Everything' },

];

const Discount = () => {
  const [fullName, setFullName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [nameError, setNameError] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [currentCoupon, setCurrentCoupon] = useState(null);
  const [copied, setCopied] = useState(false);

  const overlayRef = useRef(null);

  const validateForm = () => {
    let valid = true;

    if (!fullName.trim()) {
      setNameError('Please enter your full name');
      valid = false;
    } else {
      setNameError('');
    }

    const phoneRegex = /^[6-9]\d{9}$/;
    if (!phoneRegex.test(phoneNumber)) {
      setPhoneError('Phone number not valid');
      valid = false;
    } else {
      setPhoneError('');
    }

    return valid;
  };

  const submitForm = async () => {
    if (validateForm()) {
      const savedCoupons = JSON.parse(localStorage.getItem('submittedCoupons')) || {};

      if (savedCoupons[phoneNumber]) {
        alert('A coupon has already been claimed with this phone number. Please use a different number.');
        return;
      }

      try {
        await axios.post('http://localhost:5000/submit-form', {
          fullName,
          phoneNumber,
        });

        const random = discountTypes[Math.floor(Math.random() * discountTypes.length)];
        savedCoupons[phoneNumber] = random;

        localStorage.setItem('submittedCoupons', JSON.stringify(savedCoupons));
        setCurrentCoupon(random);
        setIsSubmitted(true);
      } catch (error) {
        if (error.response?.data?.message) {
          alert(error.response.data.message);
        } else {
          alert('Server error, please try again.');
        }
      }
    }
  };

  const closePopup = () => {
    setIsSubmitted(false);
    setCopied(false);
  };


  const handleCopy = () => {
    navigator.clipboard.writeText(currentCoupon.code)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
      })
      .catch(err => {
        console.error("Failed to copy text: ", err);
      });
  };
  const continueShopping = () => {
    closePopup();
    window.location.href = '/';
  };

  const handleOverlayClick = (e) => {
    if (e.target === overlayRef.current) {
      closePopup();
    }
  };

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') closePopup();
    };
    document.addEventListener('keydown', handleEsc);
    return () => document.removeEventListener('keydown', handleEsc);
  }, []);
  return (
    <>
      <div className="notebook-page">
        <div className="back">
          <Link to="/" className="back">
            <img src="/images/Frame 10.png" alt="back" />
          </Link>

        </div>
        <div className="main"> <div className="main-heading">Save upto 90% </div></div>

        <div className="content">
          {/* <div className="main-heading">Save upto 90% Off*</div> */}

          <div className="info-section">
            <div className="location-info">Grab your exclusive discount</div>

            {/* <div className="location-info">Lucknow 01 to 03 August 2025</div> */}
            <div className="date-time">- just share a few details!</div>
          </div>

          <div className="handwritten-line"></div>

          <div className="form-section">
            {/* <div className="form-title">Submit Your Details</div>
          <div className="form-title">And get Your Discount Coupon</div> */}

            <div className="form-group">
              <label htmlFor="fullName">Full Name</label>
              <input
                type="text"
                id="fullName"
                className="input-box"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                required
              />
              {nameError && <div className="error-message">{nameError}</div>}
            </div>

            <div className="form-group">
              <label htmlFor="phoneNumber">Phone Number</label>
              <input
                type="tel"
                id="phoneNumber"
                className="input-box"
                placeholder="Enter 10 digit number"
                maxLength="10"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                required
              />
              {phoneError && <div className="error-message">{phoneError}</div>}
            </div>

            <button type="button" className="submit-button" onClick={submitForm}>
              SUBMIT
            </button>
          </div>
        </div>




        {isSubmitted && currentCoupon && (
          <div className="popup-overlay active" ref={overlayRef} onClick={handleOverlayClick}>
            <div className="popup show">
              <button className="close-btn" onClick={closePopup}>&times;</button>

              {/* Logo */}
              <div className="logo-container">
                <img src="/images/Frame 1000003392.png" alt="logo" className="logo-image" />
              </div>

              {/* Heading */}
              <h2 className="congrats-text">Congratulations!</h2>
              <p className="sub-text">
                You've unlocked an exclusive discount coupon. Use it before it expires!
              </p>

              {/* Coupon Button */}
              <button className="coupon-button" onClick={handleCopy}>
                {currentCoupon.code}
                <span className="copy-icon"><img src="/images/Component 41.png" /></span>
              </button>

              {/* Continue Shopping */}
              <button className="continue-btn" onClick={continueShopping}>
                Continue Shopping →
              </button>

              {/* Terms */}
              <p className="terms">
                T&C Apply: Valid on purchases over ₹6,000 at Mega Fashion & Handloom during the exhibition at any
                location, 01–03 Aug 2025, 10 AM–9 PM. One-time use only. Cannot be combined with other offers.
                Discount on final bill before taxes.
              </p>

              {copied && (
                <div className="success-message">
                  ✅ Coupon code copied to clipboard!
                </div>
              )}
            </div>
          </div>

        )}
      </div>


      <div className="location-section">
        <h3><span className="location-icon">📍</span> EXHIBITION LOCATIONS</h3>
        <div className="cards">
          <div className="card">
            <h4>Kanpur - Lucknow Rd, Gopal Nagar Colony</h4>
            <p>123 Queen’s Boulevard, Sector 45</p>
            <p><FaMapMarkerAlt /> Lucknow , Uttar Pradesh</p>
            <p><FaPhoneAlt />+91 95176 33300</p>
          </div>

          <div className="card">
            <h4>Sapphire Bay Resort</h4>
            <p>78, Beachside Avenue, Near LightHouse</p>
            <p><FaMapMarkerAlt /> Varanasi, Uttar Pradesh</p>
            <p><FaPhoneAlt /> +91 98765 43210</p>
          </div>

          <div className="card">
            <h4>The Alpine Nest</h4>
            <p>123 Queen’s Boulevard, Sector 45</p>
            <p><FaMapMarkerAlt /> Lucknow, Uttar Pradesh</p>
            <p><FaPhoneAlt /> +91 98765 43210</p>
          </div>
        </div>
      </div>



    </>


  );
};

export default Discount;
